import { initializeSp4SurfaceRollout } from './surface-rollout';

export const prepareSp4SurfaceRollout = (isProLayout, initLayout) => {
    if (isProLayout) {
        initializeSp4SurfaceRollout();
    }

    return initLayout();
};
